/**
 * The API's 403 `{ error: 'module_disabled', module }` — the tenant does not
 * have `module` (a module switched off, or not in its tier). Read off the
 * ApiClientError that fetchApi throws (`statusCode` + the response `body`).
 *
 * With `module`, only a refusal for THAT module counts, so one section never
 * hides because a different module is off.
 */
export function isModuleDisabledError(err: unknown, module?: string): boolean {
  if (!err || typeof err !== 'object') return false;
  const { statusCode, body } = err as { statusCode?: unknown; body?: unknown };
  if (statusCode !== 403 || typeof body !== 'object' || body === null) return false;
  const refusal = body as { error?: unknown; module?: unknown };
  return (
    refusal.error === 'module_disabled' &&
    (module === undefined || refusal.module === module)
  );
}
